export default __webpack_public_path__ + "static/media/TVSraider_LateralIzq.1e122b14.webp";